var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('HeaderBanner'),_c('Services'),_c('ChooseUs'),_c('AboutUs'),_c('HowItWorks'),_c('ContactUs'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }